import React from "react";
import { Typography, Tag } from "antd";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { selectEnvironment } from "../store/selector";
import { selectIsDevEnvironment } from "@tailormed/common-client/store/selector";
import { useGetSetting } from "../hooks/getSetting";
import { GOLD, ERROR_600 } from "../constant/colors";

const { Text } = Typography;

const StyledContainer = styled.div`
  background-color: ${GOLD};
  text-align: center;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const EnvironmentHeaderComponent = ({ environment, isDevEnvironment }) => {
  const { t } = useTranslation();

  let simulateEnvBehaviour;
  try {
    [simulateEnvBehaviour] = useGetSetting(["env.simulateEnvBehaviour"]);
  } catch (error) {
    console.warn("Failed to get simulateEnvBehaviour setting:", error);
    simulateEnvBehaviour = null;
  }

  const isDemoMode = simulateEnvBehaviour === "demo";

  const showEnvironmentHeader = environment && isDevEnvironment;

  if (!showEnvironmentHeader) return null;

  return (
    <StyledContainer className="dont-print">
      <Text>{t("environment_header", { environment })}</Text>
      {isDemoMode && (
        <Tag color={ERROR_600} style={{ borderRadius: "6px" }}>
          {t("demo_mode")}
        </Tag>
      )}
    </StyledContainer>
  );
};

const mapStateToProps = createStructuredSelector({
  environment: selectEnvironment,
  isDevEnvironment: selectIsDevEnvironment
});

const EnvironmentHeader = connect(mapStateToProps)(EnvironmentHeaderComponent);

export { EnvironmentHeader };
